'use client'
import { useTranslateEntry } from 'src/i18n/client/useTranslateEntry'
import Crossmark from 'src/components/journals/article/components/Crossmark'
import SocialShare from 'src/components/design-system/SocialShare'
import Citation from 'src/components/publications/Citation'
import AsideMenu from 'src/components/journals/article/components/AsideMenu'
import { getPreferredTranslation } from 'src/_helpers/getPreferredTranslation'
import { normalizeBlocks } from 'src/_helpers/normalizeBlocks'
const Aside = ({ page, locale, hasAbstract, routeContext = 'main', className = '' }) => {
  const translate = useTranslateEntry()
  const isDomainJournal = routeContext === 'journal-domain'

  const blockTypeFallbackTitles = {
    bibliography: 'T_JOURNAL_ARTICLE_BLOCK_BIBLIOGRAPHY_DEFAULT_TITLE',
  }

  const ARTICLE_SECTIONS_TOP = [
    { id: 'article-publication-title', title: translate('T_PUBLICATION_TITLE') },
    hasAbstract ? { id: 'article-abstract', title: translate('T_ABSTRACT') } : null,
    { id: 'article-keywords', title: translate('T_KEYWORDS') },
  ].filter(Boolean)

  const ARTICLE_SECTIONS_BOTTOM = [
    page.otherArticlesList && page.otherArticlesList.length > 0
      ? { id: 'other-articles-from-number', title: translate('T_OTHER_ARTICLES_FROM_NUMBER') }
      : null,
    page.similarArticlesList && page.similarArticlesList.length > 0
      ? { id: 'similar-publication', title: translate('T_SIMILAR_PUBLICATION') }
      : null,
  ]

  const articleSectionsBlocks = normalizeBlocks(page?.blocks)
    .filter((block) => block.sidebar)
    .map((block) => ({
      id: block.uuid,
      blockType: block.type.value,
      title:
        getPreferredTranslation(block, locale)?.title ||
        (block.type.value && blockTypeFallbackTitles?.[block.type.value])
          ? translate(blockTypeFallbackTitles[block.type.value])
          : '',
    }))
  const articleSections = [...ARTICLE_SECTIONS_TOP, ...articleSectionsBlocks, ...ARTICLE_SECTIONS_BOTTOM]
  const title = getPreferredTranslation(page, locale)?.title || ''
  const doi = page.doi
  const showCrossrefButton = page.showCrossrefButton
  return (
    <div className={className}>
      <div className="flex flex-col items-end gap-y-24 mb-20 ">
        <div className="flex flex-items gap-x-16">
          <Citation publication={page} locale={locale} />
          <hr className={`h-24 w-1 ${isDomainJournal ? 'bg-basic-gray7' : 'bg-dark-blue-dark-blue5'}`} />
          <SocialShare title={title} />
        </div>
        {showCrossrefButton && doi && <Crossmark doi={doi} />}
      </div>
      <AsideMenu sections={articleSections} routeContext={routeContext} />
    </div>
  )
}

export default Aside
